import * as tslib_1 from "tslib";
import React from 'react';
import Divider from 'sinoui-components/Divider';
import dayjs from 'dayjs';
import CalendarDayGrid from './CalendarDayGrid';
import CalendarHeader from './CalendarHeader';
import CalendarWeekBar from './CalendarWeekBar';
import MonthSelectPanel from './MonthSelectPanel';
import YearSelectPanel from './YearSelectPanel';
import CalendarLayout from './CalendarLayout';
var Calendar = /** @class */ (function (_super) {
    tslib_1.__extends(Calendar, _super);
    // tslint:disable-next-line:no-any
    function Calendar(props) {
        var _this = _super.call(this, props) || this;
        var now = new Date();
        var monthNow = now.getMonth() + 1;
        var yearNow = now.getFullYear();
        _this.state = {
            modelState: _this.props.onlyYearMonth ? 2 : 0,
            monthLastChecked: monthNow,
            yearLastChecked: yearNow,
            monthChecked: monthNow,
            yearChecked: yearNow,
            prevAndNext: 0,
            day: 0,
            isLastChecked: false,
            allDayLastChecked: '',
        };
        _this.changeModelState = _this.changeModelState.bind(_this);
        _this.checkYear = _this.checkYear.bind(_this);
        _this.checkMonth = _this.checkMonth.bind(_this);
        _this.dateInit = _this.dateInit.bind(_this);
        _this.prevButton = _this.prevButton.bind(_this);
        _this.nextButton = _this.nextButton.bind(_this);
        _this.selectDay = _this.selectDay.bind(_this);
        return _this;
    }
    // tslint:disable-next-line:no-any
    Calendar.prototype.componentDidMount = function () {
        var dateTime = this.props.dateTime;
        this.dateInit(dateTime);
    };
    /**
     * 初始化日期
     *
     * @param {*} dateTime
     * @memberof Calendar
     */
    // tslint:disable-next-line:no-any
    Calendar.prototype.dateInit = function (dateStr) {
        var date = dateStr ? dayjs(dateStr) : dayjs();
        var month = date.month() + 1;
        var year = date.year();
        var day = date.date();
        this.setState({
            isLastChecked: !!dateStr ? true : this.state.isLastChecked,
            monthLastChecked: month,
            yearLastChecked: year,
            monthChecked: month,
            yearChecked: year,
            day: day,
        });
    };
    /**
     * 点击日历头  年部分切换日历主体
     *
     * @memberof Calendar
     */
    Calendar.prototype.changeModelState = function () {
        if (this.props.onlyYearMonth) {
            this.state.modelState === 1 || this.state.modelState === 2
                ? this.setState({ modelState: 1 })
                : this.setState({ modelState: 1 });
        }
        else {
            this.state.modelState === 1 || this.state.modelState === 2
                ? this.setState({ modelState: 0 })
                : this.setState({ modelState: 1 });
        }
    };
    /**
     * 在主体部分
     * 选择年切换月份
     *
     * @memberof Calendar
     */
    Calendar.prototype.checkYear = function (yearNum) {
        this.state.modelState === 2
            ? this.setState({
                modelState: 0,
                yearChecked: parseInt(yearNum, 10),
                isLastChecked: false,
            })
            : this.setState({
                modelState: 2,
                yearChecked: parseInt(yearNum, 10),
            });
    };
    /**
     * 在主体部分
     * 选择月份，切换为日期
     *
     * @memberof Calendar
     */
    Calendar.prototype.checkMonth = function (monthNum) {
        this.setState({
            modelState: 0,
            monthChecked: monthNum,
            isLastChecked: false,
        });
        // 选择月抛出事件
        if (this.props.onlyYearMonth) {
            this.props.onChange(this.state.yearChecked + '-' + monthNum.toString().padStart(2, '0'));
        }
    };
    // tslint:disable-next-line:no-any
    Calendar.prototype.selectDay = function (day, e) {
        e.stopPropagation();
        var selectDay = this.state.yearChecked +
            '-' +
            this.state.monthChecked.toString().padStart(2, '0') +
            '-' +
            day.toString().padStart(2, '0');
        var todayBeforeForbidden = this.props.todayBeforeForbidden;
        if (todayBeforeForbidden && selectDay < dayjs().format('YYYY-MM-DD')) {
            return;
        }
        this.setState({
            day: day,
            yearLastChecked: this.state.yearChecked,
            isLastChecked: true,
            monthLastChecked: this.state.monthChecked,
            allDayLastChecked: this.state.yearChecked + '-' + this.state.monthChecked + '-' + day,
        });
        this.props.onChange(this.state.yearChecked +
            '-' +
            this.state.monthChecked.toString().padStart(2, '0') +
            '-' +
            day.toString().padStart(2, '0'));
    };
    Calendar.prototype.prevButton = function () {
        if (this.state.modelState === 1) {
            this.setState(function (prevState) { return ({
                prevAndNext: prevState.prevAndNext - 1,
            }); });
        }
        if (this.state.modelState === 0) {
            this.setState(function (prevState) { return ({
                monthChecked: prevState.monthChecked - 1,
            }); });
            if (this.state.monthChecked === 1) {
                this.setState(function (prevState) { return ({
                    yearChecked: prevState.yearChecked - 1,
                    monthChecked: 12,
                }); });
            }
        }
        if (this.state.modelState === 2) {
            this.setState(function (prevState) { return ({
                yearChecked: prevState.yearChecked - 1,
            }); });
        }
    };
    Calendar.prototype.nextButton = function () {
        if (this.state.modelState === 1) {
            this.setState(function (prevState) { return ({
                prevAndNext: prevState.prevAndNext + 1,
            }); });
        }
        if (this.state.modelState === 0) {
            this.setState(function (prevState) { return ({
                monthChecked: prevState.monthChecked + 1,
            }); });
            if (this.state.monthChecked === 12) {
                this.setState(function (prevState) { return ({
                    yearChecked: prevState.yearChecked + 1,
                    monthChecked: 1,
                }); });
            }
        }
        if (this.state.modelState === 2) {
            this.setState(function (prevState) { return ({
                yearChecked: prevState.yearChecked + 1,
            }); });
        }
    };
    Calendar.prototype.render = function () {
        var model;
        switch (this.state.modelState) {
            case 0:
                model = (React.createElement(CalendarDayGrid, { monthChecked: this.state.monthChecked, yearChecked: this.state.yearChecked, monthLastChecked: this.state.monthLastChecked, yearLastChecked: this.state.yearLastChecked, selectDay: this.selectDay, dayNum: this.state.day, isLastChecked: this.state.isLastChecked }));
                break;
            case 1:
                model = (React.createElement(YearSelectPanel, { selectYear: this.checkYear, monthLastChecked: this.state.monthLastChecked, yearLastChecked: this.state.yearLastChecked, monthChecked: this.state.monthChecked, yearChecked: this.state.yearChecked, prevAndNext: this.state.prevAndNext, isLastChecked: this.state.isLastChecked }));
                break;
            default:
                model = (React.createElement(MonthSelectPanel, { selectMonth: this.checkMonth, monthLastChecked: this.state.monthLastChecked, yearLastChecked: this.state.yearLastChecked, monthChecked: this.state.monthChecked, yearChecked: this.state.yearChecked, isLastChecked: this.state.isLastChecked, allDayLastChecked: this.state.allDayLastChecked }));
        }
        return (React.createElement(CalendarLayout, null,
            React.createElement(CalendarHeader, { onClickYearMonthSelect: this.changeModelState, onClickPrevButton: this.prevButton, onClickNextButton: this.nextButton, yearLastChecked: this.state.yearLastChecked, monthLastChecked: this.state.monthLastChecked, monthChecked: this.state.monthChecked, yearChecked: this.state.yearChecked, modelState: this.state.modelState, prevAndNext: this.state.prevAndNext }),
            this.state.modelState === 0 && React.createElement(CalendarWeekBar, null),
            React.createElement(Divider, { style: { marginBottom: '8px' } }),
            model));
    };
    return Calendar;
}(React.Component));
export default Calendar;
//# sourceMappingURL=Calendar.js.map